import { RootState } from "@/redux/store";
import { createSlice } from "@reduxjs/toolkit";

export enum ViewType {
  SYNTHESIS = "SYNTHESIS",
  LIST = "LIST",
  ANALYSIS = "ANALYSIS",
}

export interface AppSliceState {
  currentView: ViewType;
  sideDrawerIsOpen: boolean;
}

const initialState: AppSliceState = {
  currentView: ViewType.SYNTHESIS,
  sideDrawerIsOpen: false,
};

export const appSlice = createSlice({
  name: "app",
  initialState: initialState,
  reducers: {
    setCurrentViewType: (
      state,
      {
        payload,
      }: {
        payload: ViewType;
      },
    ) => {
      state.currentView = payload;
    },
    setSideDrawerIsOpen: (
      state,
      {
        payload,
      }: {
        payload: boolean;
      },
    ) => {
      state.sideDrawerIsOpen = payload;
    },
  },
});

export const appSelectors = {
  getCurrentViewType: (state: RootState) => state.app.currentView,
  getSideDrawerIsOpen: (state: RootState) => state.app.sideDrawerIsOpen,
};

export const appActions = appSlice.actions;
export default appSlice.reducer;
